/**
 * A multiline field that takes ONE line of the table until it is being edited.
 *
 * Description and offer remark are multiline (size, spec, packing on their own lines), but a
 * table of a hundred lines cannot afford a five-row box on every one of them — the page ran to
 * several screens of mostly empty boxes. So: one line, ellipsised, while idle; the full text,
 * grown to its lines (capped), while focused. The saved value is untouched by any of this —
 * height is presentation, and the field commits exactly as before.
 */

import { useState, type TextareaHTMLAttributes } from 'react'
import { textareaRows } from '../lib/textareaRows'

export function LineTextarea({
  value,
  style,
  onFocus,
  onBlur,
  ...rest
}: Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'value' | 'rows'> & { value: string }) {
  const [focused, setFocused] = useState(false)
  return (
    <textarea
      {...rest}
      className={`linefield${rest.className ? ` ${rest.className}` : ''}`}
      value={value}
      // Grows only while edited; at rest every row is one line tall whatever it holds.
      rows={focused ? Math.max(2, textareaRows(value)) : 1}
      style={{ width: '100%', fontFamily: 'inherit', ...style }}
      onFocus={(e) => {
        setFocused(true)
        onFocus?.(e)
      }}
      onBlur={(e) => {
        setFocused(false)
        onBlur?.(e)
      }}
    />
  )
}
